export default __webpack_public_path__ + "static/media/img3.5612ccf8.jpg";